import * as Action from '../action';

export default (state = {}, action) => {
  switch (action.type) {
    case Action.ADD_CONTAINER_TRACKING_DETAIL:
      return { ...action.value };
    default:
      return state;
  }
};
